import React from "react";
import { FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";

const SubjectHeader = () => {

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
      <Link
        to={`/master/add-subject`}
        className="btn btn-primary"
      >
        <FiPlus size={16} className="me-2" />
        <span>Create Subject</span>
      </Link>
    </div>
  );
};

export default SubjectHeader;
